import DatasHero from './DatasHero'
import DatasTable from './DatasTable'
import DesignHero from './DesignHero'
import DoubleImage from './DoubleImage'
import GalleryViewer from './GalleryViewer'
import HandwriteImage from './HandwriteImage'
import LargeQuote from './LargeQuote'
import LifestyleHero from './LifestyleHero'
import NextSection from './NextSection'
import SingleImage from './SingleImage'
import SingleParagraph from './SingleParagraph'
import Spacer from './Spacer'

export const sectionsMap: any = {
  datas_hero: DatasHero,
  datas_table: DatasTable,
  design_hero: DesignHero,
  double_image: DoubleImage,
  gallery_viewer: GalleryViewer,
  handwrite_image: HandwriteImage,
  large_quote: LargeQuote,
  lifestyle_hero: LifestyleHero,
  next_section: NextSection,
  single_image: SingleImage,
  single_paragraph: SingleParagraph,
  spacer: Spacer
}
